import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { clog } from "@libs/utils";
import { getDownloadSnacks } from "@modules/core/store/selectors";
import DownloadSnackBar from "../DownloadSnackBarProvider/DownloadSnackBar";
import Snackbar from "@mui/material/Snackbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const DownloadSnackBarProvider: FC = (props) => {
  const downloadSnacks = useSelector(getDownloadSnacks);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    clog("DownloadSnackBarProvider Rendered", downloadSnacks);
    if (downloadSnacks && downloadSnacks.length > 0) {
      clog(
        "Snack Bars Updated:",
        downloadSnacks.map((snack) => snack.id).join(", "),
      );
    }

    setRefresh(true);
  }, [downloadSnacks]);

  return (
    <>
      {downloadSnacks?.length && downloadSnacks.length > 0 ? (
        <Snackbar
          open={downloadSnacks.length > 0}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Box display={"flex"} flexDirection="column" p={2}>
            <Stack spacing={2} sx={{ mb: 6 }} direction="column">
              {downloadSnacks.map((snackBar) => (
                <DownloadSnackBar key={snackBar.id} {...snackBar} />
              ))}
            </Stack>
          </Box>
        </Snackbar>
      ) : null}
    </>
  );
};

export default DownloadSnackBarProvider;
